import { JWWSPflegestatusEnum } from "FoxxyInterfaces";



export enum JWWSPflegestatusGraphqlEnum {
  Advent_Weihnachten = "ADVENT_WEIHNACHT",
  Automatisch_erstellt = "AUTOMATISCHERSTELLT",
  Ostern = "OSTERN",
  Saison = "SAISON"

}



export class StatusPflegeSortimentierenDefaults {

  static list: JWWSPflegestatusDef[] = [
    <JWWSPflegestatusDef>{ id: JWWSPflegestatusEnum.automatischerstellt, value: JWWSPflegestatusGraphqlEnum.Automatisch_erstellt, text: "Automatisch erstellt", iconstyle: "color: gray;" },
    <JWWSPflegestatusDef>{ id: JWWSPflegestatusEnum.ATitel, value: JWWSPflegestatusGraphqlEnum.Saison, text: "Saison", iconstyle: "" },
    <JWWSPflegestatusDef>{ id: JWWSPflegestatusEnum.AdventWeihnacht, value: JWWSPflegestatusGraphqlEnum.Advent_Weihnachten, text: "Advent / Weihnachten", iconstyle: "" },
    <JWWSPflegestatusDef>{ id: JWWSPflegestatusEnum.Ostern, value: JWWSPflegestatusGraphqlEnum.Ostern, text: "Ostern", iconstyle: "" },
  ];

  static getValidList(): JWWSPflegestatusDef[] {
    return StatusPflegeSortimentierenDefaults.list.filter(l=>
      l.value == JWWSPflegestatusGraphqlEnum.Automatisch_erstellt ||  l.value == JWWSPflegestatusGraphqlEnum.Advent_Weihnachten || l.value == JWWSPflegestatusGraphqlEnum.Ostern      || l.value == JWWSPflegestatusGraphqlEnum.Saison        )  }
}

export class JWWSPflegestatusDef {
  value: JWWSPflegestatusGraphqlEnum;
  text: string;
  iconstyle: string;
  id: JWWSPflegestatusEnum;

}
